import { cn } from "@homeinstead/ui";
import ArrowSVG from "./arrow.svg";

const ArrowRounded = ({ className }: { className?: string }) => {
  return <ArrowSVG className={cn("fill-new-beginnings-base", className)} />;
};

export default ArrowRounded;
